import { mapState } from 'vuex';
import draggable from 'vuedraggable';
export default {
  name: 'AutocompleteReorderable',
  components: {
    draggable
  },
  props: {
    value: {
      type: Array,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    dataCy: {
      type: String,
      required: false,
      default: 'draggable-selector'
    }
  },
  data() {
    return {
      isDragging: false
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    selectedValues: {
      get() {
        return Array.isArray(this.value) ? this.value : [];
      },
      set(newValues) {
        this.$emit('input', Array.isArray(newValues) ? newValues : []);
      }
    }
  },
  methods: {
    getOptionLabel(value) {
      const option = this.options.find(item => item.value === value);
      return option ? option.text : value;
    },
    removeItem(index) {
      this.selectedValues = this.selectedValues.filter((_, i) => i !== index);
    }
  }
};